import StatusChip from './StatusChip';

export default StatusChip;
